import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/spherical-images'
)({
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['all', 'gallery']).optional(), 'all'),
    })
  ),
  staticData: {
    breadcrumb: () => <I18nBreadcrumb translationKey="360Images" />,
  },
});
